import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import Media from 'react-media'
import {Link} from 'react-router'
import NavLink from '../Component/NavLink'
import Logo from '../images/jeyutex-logo-top.png'
import * as firebase from 'firebase'
import {browserHistory} from 'react-router'


const Jeyu = {
  logo: {
    backgroundImage: 'url('+Logo+')',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    display: 'block',
    width: 180,
    height: 60
  },
  mobilenav: {
    position: 'absolute',
    left: 10
  },
  mobilenavinfo: {
    margin: '10% 0 0 5px',
  },
  lightbox: {
    background: 'rgba(0,0,0,.8)',
    height: '100vh',
    position: 'fixed',
    width: '100%',
    zIndex: 9,
    left: 0,
    top: 0
  },
  dealer: {
    color: '#ffab12',
    border: '1px solid #ffab12',
    padding: '5px 15px 7px',
    borderRadius: 5
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10
  },
  mobilemenu: {
    height: 3,
    width: 25,
    background: '#fff',
    margin: '5px 0'
  }
}

class MobileNav extends Component {
  componentDidMount() {
   window.scrollTo(0, 0)
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }
  render() {
    return(
      <div style={Jeyu.lightbox}>
       <div style={Jeyu.mobilenavinfo} className="mobilenavinfo">
        <NavLink to="/Dashboard">管理首頁</NavLink>
       </div>
      </div>
    )
  }
}

export default class AdminHeader extends Component {
  constructor() {
  super();
  this.state = {
    height: '',
    showReply: false,
  }
   this.handleScroll = this.handleScroll.bind(this)
   this.toggle = this.toggle.bind(this)
   this.logout = this.logout.bind(this)
  }
  logout() {
    firebase.auth().signOut().then(() => {
      browserHistory.push('/Login')
    }).catch((error) => {
      alert('錯誤')
    })
  }
  toggle(e) {
   e.preventDefault();
   this.setState({showReply: !this.state.showReply})
  }
  componentDidMount() {
   window.addEventListener('scroll', this.handleScroll);
//  const height = document.getElementById('content').clientHeight;
   const top = document.body.scrollTop
   this.setState({top})
  }
  componentWillUnmount() {
   window.removeEventListener('scroll', this.handleScroll);
   const top = document.body.scrollTop
   this.setState({top})
  }
  handleScroll(e) {
   const windowsScrollTop = window.pageYOffset
   const header = ReactDOM.findDOMNode(this.refs.header)
   if(this.state.top >= windowsScrollTop) {
    console.log(this.state.top)
    header.classList.remove('change')
   } else {
    console.log('scrollTop')
    header.classList.add('change')
   }
  }
  render() {
    return(
      <div className="header" ref="header">
      <Media query="(max-width:1200px)">
       {matches => matches ? (
         <div className="container">
          <div className="row">
          <div className="lg-2">
           <Link to="/" style={Jeyu.logo} onClick={this.gotop}></Link>
          </div>
          <div className="lg-10">
          <div className="nav" style={Jeyu.center}>
           <a onClick={this.toggle}>
            <div style={Jeyu.mobilemenu}></div>
            <div style={Jeyu.mobilemenu}></div>
            <div style={Jeyu.mobilemenu}></div>
           </a>
           <div onClick={this.toggle}>
            {this.state.showReply && <MobileNav />}
           </div>
          </div>
          </div>
          </div>
         </div>
       ) : (
         <div className="container">
          <div className="row">
           <div className="md-3 lg-3">
            <Link to="/" style={Jeyu.logo}></Link>
           </div>
           <div className="md-offset-3 md-6 lg-offset-3 lg-6">
            <div className="nav" style={Jeyu.center}>
             <NavLink to="/Dashboard">管理首頁</NavLink>
             <a href="#" onClick={this.logout}>登出</a>
            </div>
           </div>
          </div>
         </div>
       )}
      </Media>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layout/AdminHeader.js